"use client"

import Image from "next/image"

/**
 * Shared layout shell for the unauthenticated auth pages (login,
 * accept-invite, reset-password).
 *
 * Two-column on lg+: a branded left panel + a centred right card where the
 * page-specific form is rendered as children.
 */
export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background flex">
      {/* Left panel - branding (hidden on small screens for mobile-first). */}
      <div className="hidden lg:flex w-1/2 bg-primary flex-col justify-between p-12">
        <div />
        <div className="space-y-4 max-w-sm">
          <h1 className="text-4xl font-bold text-primary-foreground leading-tight">
            From first experiment<br />to finished batch, one connected system.
          </h1>
          <p className="text-primary-foreground/70 text-lg leading-relaxed">
            AI that understands your business, surfaces institutional knowledge, and keeps your R&D data from walking out the door.
          </p>
          <div className="space-y-2 pt-2">
            {[
              "Record every experiment, QC record and production batches seamlessly",
              "Every failed run trains future decisions",
              "Search across experiments, batches, and formulations",
              "Unified AI assistant across all R&D modules",
            ].map((point) => (
              <div key={point} className="flex items-center gap-2.5">
                <div className="h-1.5 w-1.5 rounded-full bg-primary-foreground/50 shrink-0" />
                <p className="text-sm text-primary-foreground/80">{point}</p>
              </div>
            ))}
          </div>
        </div>
        <p className="text-xs text-primary-foreground/40">
          © 2026 DXTR · Confidential
        </p>
      </div>

      {/* Right panel - page content. */}
      <div className="flex flex-1 items-center justify-center p-6 md:p-8">
        <div className="w-full max-w-sm space-y-8">
          <div className="flex justify-center">
            <div className="relative h-[52px] w-[229px]">
              <Image src="/58146_DXTRlab_RM-02.png" alt="DXTR Lab" fill className="object-contain" />
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
